import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Struct } from "../codec/Struct.mjs";
import { UNMASK_VERSION } from "./constants.mjs";
/**
 * @name GenericExtrinsicUnknown
 * @description
 * A default handler for extrinsics where the version is not known (default throw)
 */

export var GenericExtrinsicUnknown =
/*#__PURE__*/
function (_Struct) {
  _inherits(GenericExtrinsicUnknown, _Struct);

  function GenericExtrinsicUnknown(registry, value) {
    var _this;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$isSigned = _ref.isSigned,
        isSigned = _ref$isSigned === void 0 ? false : _ref$isSigned,
        _ref$version = _ref.version,
        version = _ref$version === void 0 ? 0 : _ref$version;

    _classCallCheck(this, GenericExtrinsicUnknown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GenericExtrinsicUnknown).call(this, registry, {}));
    throw new Error("Unsupported ".concat(isSigned ? '' : 'un', "signed extrinsic version ").concat(version & UNMASK_VERSION));
    return _this;
  }

  return GenericExtrinsicUnknown;
}(Struct);